const TransactionHistory = {
  getAllTransaction: {
    url: "/transactions",
    method: "GET",
  },
};

export default TransactionHistory;
